import { convertActionToPreviousStructure } from 'app/api';
import type { RecordOfBettingEntitiesState } from 'app/lib/betting/betting-entities';

import {
  fetchSearchedValue,
  FetchSearchedValueFailure,
  FetchSearchedValueRequest,
  FetchSearchedValueSuccess,
  RESET_SEARCHED_VALUE,
  ResetSearchedValueActionType,
} from '../actions';
import { reduceGrid } from './entities';

export type SearchState = Map<string, Record<string, unknown> | undefined>;

const initialState = new Map<string, RecordOfBettingEntitiesState>();

type SearchActions =
  | FetchSearchedValueRequest
  | FetchSearchedValueSuccess
  | FetchSearchedValueFailure
  | ResetSearchedValueActionType;

export default function (state = initialState, action: SearchActions): SearchState {
  switch (action.type) {
    case fetchSearchedValue.pending.toString():
    case fetchSearchedValue.fulfilled.toString():
    case fetchSearchedValue.rejected.toString():
      return setMatchesFound(state, convertActionToPreviousStructure(action));

    case RESET_SEARCHED_VALUE:
      return setMatchesFound(state, action);

    default:
      return state;
  }
}

function setMatchesFound(
  state: Map<string, RecordOfBettingEntitiesState>,
  action: SearchActions,
) {
  return new Map(state).set('matchesFound', reduceGrid(state.get('matchesFound'), action));
}
